// extracted by mini-css-extract-plugin
module.exports = {"title":"Newsletter_title__3ZE8B"};